let cookieValue = document.cookie.match('(^|;) ?' + 'wishlist' + '=([^;]*)(;|$)');
let wishlistArray = cookieValue ? JSON.parse(cookieValue[2]) : [];
const allWishHeadLink = document.querySelectorAll('.wishlist_link');
let pageWishlistHead, pageWishlistEmptyHead, pageWishlistLink, parentElement;

if (window.location.pathname == '/pages/wishlist') {
  pageWishlistHead = document.getElementById('page-wishlist-head');
  pageWishlistEmptyHead = document.getElementById('page-wishlist-empty-head');
  pageWishlistLink = document.getElementById('page-wishlist-link');
  parentElement = document.querySelector('.grid.product-grid.wishlist');
}
const setAttribute = () => {
  if (wishlistArray.length) {
    allWishHeadLink?.forEach(link =>{
      link.classList.add('active');
      link.querySelector('.wishlist-bubble').classList.remove('hidden');
      link.querySelector('.wishlist-bubble').innerText = wishlistArray.length;
    });
    if (window.location.pathname == '/pages/wishlist') {
      pageWishlistLink.style.display = 'none';
      pageWishlistEmptyHead.style.display = 'none';
      pageWishlistHead.style.display = 'block';
    }
  } else {
    allWishHeadLink?.forEach(link =>{
      link.classList.remove('active')
      link.querySelector('.wishlist-bubble').classList.add('hidden');
      link.querySelector('.wishlist-bubble').innerText = '';
    });
    if (window.location.pathname == '/pages/wishlist') {
      pageWishlistLink.style.display = 'flex';
      pageWishlistEmptyHead.style.display = 'block';
      pageWishlistHead.style.display = 'none';
    }
  }
}

setAttribute();

class wishlistBtn extends HTMLElement {
  constructor() {
    super();
    if (wishlistArray.find(obj => obj.var === this.dataset.var)){
      this.classList.add('active');
    }
    this.addEventListener('click', (e)=> {
    //  this.querySelector('.loading__spinner').classList.remove('hidden');
      
      let newArray = {};
      if (!wishlistArray.find(obj => obj.var === this.dataset.var)){
        newArray.id = this.dataset.id;
        newArray.handle = this.dataset.handle;
        newArray.var = this.dataset.var;
        wishlistArray.push(newArray);
      } else {
        wishlistArray = wishlistArray.filter(obj => obj.var!== this.dataset.var);
      }
      
      let arrayString = JSON.stringify(wishlistArray);
      let expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 30);
      
      document.cookie = `wishlist=${arrayString}; expires=${expirationDate.toUTCString()}; path=/`;
      
      setAttribute();
      if (window.location.pathname == '/pages/wishlist') {
        this.closest('li.grid__item').remove();
      } else {
        setTimeout(() => {
          if (this.classList.contains('active')) {
            this.classList.remove('active');
          } else {
            this.classList.add('active');
          }
         this.querySelector('.loading__spinner').classList.add('hidden');
        }, 1500);
      }
    })
  }
  
}
customElements.define("wishlist-btn", wishlistBtn);